const KEY = "reelvault_progress";
const DONE = 0.95; // treat >=95% as finished
const MIN = 5; // ignore first few seconds

const read = () => {
  try {
    return JSON.parse(localStorage.getItem(KEY)) || {};
  } catch {
    return {};
  }
};

export const getProgressMap = () => read();

export const getProgress = (id) => read()[id] || null;

export const saveProgress = ({ video_id, timestamp, duration, title, thumb }) => {
  if (!video_id || !duration) return;
  const map = read();
  const pct = timestamp / duration;
  if (pct >= DONE || timestamp < MIN) {
    delete map[video_id];
  } else {
    map[video_id] = { video_id, timestamp, duration, title, thumb, updated: Date.now() };
  }
  localStorage.setItem(KEY, JSON.stringify(map));
  window.dispatchEvent(new Event("progress-change"));
};

export const clearProgress = (id) => {
  const map = read();
  delete map[id];
  localStorage.setItem(KEY, JSON.stringify(map));
  window.dispatchEvent(new Event("progress-change"));
};

export const getContinueList = () =>
  Object.values(read())
    .filter((p) => p.duration && p.timestamp / p.duration < DONE && p.timestamp >= MIN)
    .sort((a, b) => b.updated - a.updated);
